
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import NavigationLink from './navigation-link'
import NavigationLinkIcon from './navigation-link-icon'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "navigationlink"
    }}>{`NavigationLink`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "navigation-link"
    }}>{`Navigation link`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For primary navigation such as the product masthead.`}</p>
    <Playground __position={1} __code={'<NavigationLink text=\"Navigation link\" href=\"/components-navigation-link\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' mdxType="NavigationLink" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={2} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' selected mdxType="NavigationLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link--icon"
    }}>{`Navigation link + icon`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For primary navigation such as the product masthead. Icons can add extra definition.`}</p>
    <Playground __position={4} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"account\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='account' mdxType="NavigationLinkIcon" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={5} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"account\"\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='account' selected mdxType="NavigationLinkIcon" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link-inverse"
    }}>{`Navigation link (inverse)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For primary navigation such as the product masthead.`}</p>
    <Playground __position={7} __code={'<NavigationLink\n  text=\"Navigation link\"\n  alt=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' alt='Navigation link' href='/components-navigation-link' inverse mdxType="NavigationLink" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={8} __code={'<NavigationLink\n  text=\"Navigation link\"\n  alt=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' alt='Navigation link' href='/components-navigation-link' inverse selected mdxType="NavigationLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link--icon-inverse"
    }}>{`Navigation link + icon (inverse)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For primary navigation such as the product masthead. Icons can add extra definition.`}</p>
    <Playground __position={10} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  alt=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' alt='Navigation link + icon' href='/components-navigation-link' icon='search' inverse mdxType="NavigationLinkIcon" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={11} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  alt=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' alt='Navigation link + icon' href='/components-navigation-link' icon='search' inverse selected mdxType="NavigationLinkIcon" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link-inverse-secondary"
    }}>{`Navigation link (inverse, secondary)`}</h2>
    <h3 {...{
      "id": "description-4"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer.`}</p>
    <Playground __position={13} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary inverse mdxType="NavigationLink" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={14} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary inverse selected mdxType="NavigationLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link--icon-inverse-secondary"
    }}>{`Navigation link + icon (inverse, secondary)`}</h2>
    <h3 {...{
      "id": "description-5"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer. Icons can add extra definition.`}</p>
    <Playground __position={16} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary inverse mdxType="NavigationLinkIcon" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={17} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary inverse selected mdxType="NavigationLinkIcon" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link-inverse-secondary-major"
    }}>{`Navigation link (inverse, secondary, major)`}</h2>
    <h3 {...{
      "id": "description-6"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer, with items of lower priority.`}</p>
    <Playground __position={19} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  major\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary major inverse mdxType="NavigationLink" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={20} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  major\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary major inverse selected mdxType="NavigationLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link--icon-inverse-secondary-major"
    }}>{`Navigation link + icon (inverse, secondary, major)`}</h2>
    <h3 {...{
      "id": "description-7"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer, with items of lower priority. Icons add extra definition.`}</p>
    <Playground __position={22} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  major\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary major inverse mdxType="NavigationLinkIcon" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={23} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  major\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary major inverse selected mdxType="NavigationLinkIcon" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link-inverse-secondary-minor"
    }}>{`Navigation link (inverse, secondary, minor)`}</h2>
    <h3 {...{
      "id": "description-8"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer.`}</p>
    <Playground __position={25} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  minor\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary minor inverse mdxType="NavigationLink" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={26} __code={'<NavigationLink\n  text=\"Navigation link\"\n  href=\"/components-navigation-link\"\n  secondary\n  minor\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLink text='Navigation link' href='/components-navigation-link' secondary minor inverse selected mdxType="NavigationLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "navigation-link--icon-inverse-secondary-minor"
    }}>{`Navigation link + icon (inverse, secondary, minor)`}</h2>
    <h3 {...{
      "id": "description-9"
    }}>{`Description`}</h3>
    <p>{`For secondary navigation such as the product footer. Icons add extra definition.`}</p>
    <Playground __position={28} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  minor\n  inverse\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary minor inverse mdxType="NavigationLinkIcon" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={29} __code={'<NavigationLinkIcon\n  text=\"Navigation link + icon\"\n  href=\"/components-navigation-link\"\n  icon=\"search\"\n  secondary\n  minor\n  inverse\n  selected\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      NavigationLink,
      NavigationLinkIcon
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <NavigationLinkIcon text='Navigation link + icon' href='/components-navigation-link' icon='search' secondary minor inverse selected mdxType="NavigationLinkIcon" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={NavigationLink} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;